// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"bc3a822d","107":"2b8edb00","180":"1d4b257a","274":"08dea3c7","516":"f28b33ee"}[chunkId] + ".chunk.js";
};